// Curated set of Material Symbols glyph names offered in the admin product icon
// picker. `icon_key` is stored as one of these glyph names and rendered on the
// public form using the Material Symbols ligature font (see theme.js
// `materialSymbolSx`), so anything here must be a real Material Symbols Outlined
// glyph. This list is intentionally a vetted, GIS/imagery-themed subset of the
// full ~3,500-glyph catalog; the picker also accepts free-text entry for any
// other valid glyph not listed here. Includes every glyph used by the seed
// catalog so existing products always resolve to a grid entry.

export const PRODUCT_ICON_KEYS = Object.freeze([
  // Imagery & photography
  'photo_camera',
  'image',
  'collections',
  'satellite_alt',
  'flight',
  'panorama',
  'compare',
  'hdr_strong',
  // Maps & geography
  'map',
  'layers',
  'public',
  'place',
  'explore',
  'terrain',
  'landscape',
  'travel_explore',
  'pin_drop',
  'my_location',
  // Terrain, environment & nature
  'park',
  'forest',
  'grass',
  'water',
  'water_drop',
  'agriculture',
  'eco',
  'wb_sunny',
  // 3D, modeling & analysis
  'view_in_ar',
  'deployed_code',
  'architecture',
  'square_foot',
  'straighten',
  'grid_on',
  'analytics',
  'insights',
  'monitoring',
  'query_stats',
  // Infrastructure & buildings
  'apartment',
  'location_city',
  'foundation',
  'roofing',
  'electrical_services',
  'route',
  'traffic',
  'bolt',
  // Data & documents
  'description',
  'folder',
  'cloud',
  'cloud_download',
  'dataset',
  'table_chart',
  'category',
  'inventory_2',
]);

// True when a glyph name is part of the curated grid (vs. a free-text entry).
export const isCuratedProductIcon = (key) => PRODUCT_ICON_KEYS.includes(key);
